<template>
  <new-modal-wrapper
    cta-secondary-button="personalizeRemove"
    modal-name="newEmbroideryModal"
    widthModal="92%"
    ref=embroideryModal
    :headerTitle="translations.embroideryModalTitle"
    :click-to-close="false"
    :cta-primary-button="ctaButtons[componentName]"
    :disable-buttons="disableButtons"
    @before-open="beforeOpenModal"
    @cta-action="$refs.content.ctaAction ? $refs.content.ctaAction() : $modal.hide('embroideryModal')"
    @cta-secondary-action="removePersonalization"
    @go-back="$refs.content.goBackAction ? $refs.content.goBackAction() : $modal.hide('embroideryModal')"
    @closed="closeModal"
  >
    <component
      ref=content
      :is="componentName"
      @showBackButton="showBackButton"
      @blockCtaPrimaryButton="blockCtaPrimaryButton"
      @disableButtons="setDisableButtons"
    ></component>
  </new-modal-wrapper>
</template>

<script>

import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';
import personalizationMainView from '@/components/Embroidery/MainView';
import personalizationConfirmView from '@/components/Embroidery/ConfirmView';

import embroidery from '@/mixins/Embroidery';

export default {
  name: "embroidery",
  components: {
    newModalWrapper,
    personalizationMainView,
    personalizationConfirmView,
  },
  mixins: [embroidery],
  methods: {
    /**
     * @function beforeOpenModal
     * @description Before Modal Opens
     * This method is used to check if the Modal is Starting over
     */
    beforeOpenModal() {
      const isPersonalized = this.$store.getters["personalization/isPersonalizationInComponentRecipe"]();

      this.$refs.embroideryModal.showCtaSecondaryButton(isPersonalized);
    },
    /**
     * @function removePersonalization
     * Removes Personalization
     */
    removePersonalization() {
      const componentName = this.$store.getters['personalization/getPersonalizationComponentName'];

      this.cleanPreviousEmbroidery(this.recipe_v2.components[componentName].personalization);
      this.$personalization.removePersonalization();
      this.$refs.embroideryModal.closeAction();
    },
    showBackButton(value) {
      this.$refs.embroideryModal.showBackButton(value);
    },
    blockCtaPrimaryButton(value) {
      const tooltip = value && this.componentName === 'personalizationMainView' ?
        {
          placement: 'top-center',
          trigger: 'hover',
          classes: 'embroidery-main-view-label-tooltip spaced',
          container: false,
          content: `<div>
            <div class="embroidery-main-view-label-tooltip-error-icon">!</div>
            <p>${ this.translations["personalizeDesc4"] }<br>${ this.translations["personalizeDesc5"] }</p>
          </div>`,
        } : null;

      this.$refs.embroideryModal.tooltipCtaPrimaryButton(tooltip);
      this.$refs.embroideryModal.blockCtaPrimaryButton(value);
    },
  },
};
</script>
